// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"f9d1aa28","363":"c0549de4","453":"09ce9b11","525":"d8d9020b","605":"051c1b29","634":"86a5c738","990":"eda9573a"}[chunkId] + ".chunk.js";
};